import { Tab, TabList, TabPanel, Tabs, Typography } from '@mui/joy'
import { globalStyles } from '@styles/styles'
import React from 'react'

interface TabProps {
  title: string
  content: JSX.Element
  hidden?: boolean
}
interface TabContentProps {
  tabs: TabProps[]
}

export const TabContent = ({ tabs }: TabContentProps) => {
  const tabsToShow = tabs.filter(({ hidden }) => !hidden)
  return (
    <Tabs defaultValue={0}>
      <TabList>
        {tabsToShow.map((tab, index) => (
          <Tab
            color="primary"
            key={index}
            sx={{
              '&.Mui-selected .MuiTypography-root': {
                fontWeight: 'bold',
              },
              '&:not(.Mui-selected) .MuiTypography-root': {
                color: globalStyles.secondaryTextColor,
              },
            }}
          >
            <Typography level={'title-lg-light'}>{tab.title}</Typography>
          </Tab>
        ))}
      </TabList>
      {tabsToShow.map((tab, index) => (
        <TabPanel
          value={index}
          key={index}
        >
          {tab.content}
        </TabPanel>
      ))}
    </Tabs>
  )
}
